import { useState, useEffect } from 'react';
import api from '../../../../api/axios';
import { useNavigate } from 'react-router-dom';
import { useLoading } from '../../../../components/LoadingProvider';
import useAuth from '../../../../hooks/useAuth';
import { showSuccess, showError } from '../../../../utils/toast';
import { getPublicImgUrl } from '../../../../utils/common';

export default function AppointmentPage() {
    const { setIsLoading } = useLoading();
    const navigate = useNavigate();
    const { user, isAuthenticated, userRole } = useAuth({ redirectPath: '/login', allowedRoles: ['patient'] });
    document.title = 'Varosa - Patient Appointments';
    
    const [appointments, setAppointments] = useState({
        upcoming: [],
        ongoing: [],
        previous: []
    });
    useEffect(() => {
        fetchAppointments();
    }, []);
    const fetchAppointments = async () => {
        try {
            setIsLoading(true);
            const response = await api.get(`/${userRole}/appointments`);
            if (response?.data?.result === 'success') {
                setAppointments({
                    upcoming: response?.data?.data?.upcoming_appointments || [],
                    ongoing: response?.data?.data?.ongoing_appointments || [],
                    previous: response?.data?.data?.completed_appointments || []
                });
                return;
            } else if (response?.data?.result === 'failed') {
                showError(response?.data?.message);
                if(response?.data?.errors){
                    response?.data?.errors.forEach((item, index, arr) => {
                        showError(item);
                    });
                }
            } else {
                showError('Something went wrong! Please try again later.');
            }
        } catch (error) {
            showError('Error fetching appointments:', error?.response?.data?.message || error.message);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <>
            <div className="container py-5 login-container">
                <div className="row g-3">
                    <div className="col-9">
                        <h2 className="mb-2">My Appointments</h2>
                        <p className="mb-4"><b>Support & Helpline (10am-6pm):</b> +91 8240112175 <br /><b>Office Number:</b> +91 3482329183</p>
                    </div>
                    <div className="col-3 text-end">
                        <button onClick={() => window.history.go(-1)} className="btn btn-primary">Back</button>
                    </div>
                </div>
                {appointments.upcoming.length > 0 && (
                <div className="container pt-4">
                    <div className="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="sub-style">
                            <h4 className="sub-title px-3 mb-0">Upcoming Appointments</h4>
                        </div>
                    </div>
                    <div className="row g-3">
                        {/* <h4 className="mb-4">Upcoming Appointments</h4> */}
                        {appointments.upcoming.map((item, index, arr) => (
                            <div className="col-md-4 wow fadeInUp" data-wow-delay="0.1s" key={item.id}>
                                <div className="team-item rounded">
                                    <div className="team-img rounded-top h-100 border border-primary border-bottom-0 pt-3">
                                        <img src={item.doctor_profile_picture || (getPublicImgUrl()+'/doctor_2785482.png')} className="img-fluid rounded-top w-100" style={{ maxHeight: '250px', objectFit: 'contain' }} alt="" />
                                    </div>
                                    <div className="team-content text-center border border-primary border-top-0 rounded-bottom p-4">
                                        <h5 className="mb-2">{item.doctor_name}</h5>
                                        <div className="appointment-item-div mb-3"><span className="text-start"><b>Date:</b></span> <span className="text-end">{item.appointment_date}</span></div>
                                        <div className="appointment-item-div mb-3"><span className="text-start"><b>Time:</b></span> <span className="text-end">{item.appointment_time}</span></div>
                                        {/* <div className="appointment-item-div mb-3"><span className="text-start"><b>Reason:</b></span> <span className="text-end">{item.visit_reason}</span></div> */}
                                        <div className="appointment-item-div mb-3"><span className="text-start"><b>Payment Status:</b></span> <span className="text-end">{item.payment_status ?? 'N/A'}</span></div>
                                        <div className="appointment-item-div mb-3"><span className="text-start"><b>Booking Status:</b></span> <span className="text-end">{item.booking_status ?? 'N/A'}</span></div>
                                        <div className="appointment-item-div mb-3"><span className="text-start"><b>Paid Amount:</b></span> <span className="text-end"><b>&#8377;{item.paid_amount}</b></span></div>
                                        <hr />
                                        <button type="button" onClick={() => navigate(`/dashboard/patient/appointment/${item.id}`)} className="btn btn-primary">View Details</button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                )}
                {appointments.ongoing.length > 0 && (
                <div className="container pt-4">
                    <div className="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="sub-style">
                            <h4 className="sub-title px-3 mb-0">Ongoing Appointments</h4>
                        </div>
                    </div>
                    <div className="row g-3 justify-content-center">
                        {/* <h4 className="mb-4">Ongoing Appointments</h4> */}
                        {appointments.ongoing.map((item, index, arr) => ( 
                            <div className="col-md-4 wow fadeInUp" data-wow-delay="0.1s" key={item.id}>
                                <div className="team-item rounded">
                                    <div className="team-img rounded-top h-100 border border-primary border-bottom-0 pt-3">
                                        <img src={item.doctor_profile_picture || (getPublicImgUrl()+'/doctor_2785482.png')} className="img-fluid rounded-top w-100" style={{ maxHeight: '250px', objectFit: 'contain' }} alt="" />
                                    </div>
                                    <div className="team-content text-center border border-primary border-top-0 rounded-bottom p-4">
                                        <h5 className="mb-2">{item.doctor_name}</h5>
                                        <div className="appointment-item-div mb-3"><span className="text-start"><b>Date:</b></span> <span className="text-end">{item.appointment_date}</span></div>
                                        <div className="appointment-item-div mb-3"><span className="text-start"><b>Time:</b></span> <span className="text-end">{item.appointment_time}</span></div>
                                        {/* <div className="appointment-item-div mb-3"><span className="text-start"><b>Reason:</b></span> <span className="text-end">{item.visit_reason}</span></div> */}
                                        <div className="appointment-item-div mb-3"><span className="text-start"><b>Payment Status:</b></span> <span className="text-end">{item.payment_status ?? 'N/A'}</span></div>
                                        <div className="appointment-item-div mb-3"><span className="text-start"><b>Booking Status:</b></span> <span className="text-end">{item.booking_status ?? 'N/A'}</span></div>
                                        <div className="appointment-item-div mb-3"><span className="text-start"><b>Fees:</b></span> <span className="text-end"><b>&#8377;{item.total_amount}</b></span></div>
                                        <hr />
                                        <button type="button" onClick={() => navigate(`/dashboard/patient/appointment/${item.id}`)} className="btn btn-primary">View Details</button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                )}
                {appointments.previous.length > 0 && (
                <div className="container pt-4">
                    <div className="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="sub-style">
                            <h4 className="sub-title px-3 mb-0">Previous Appointments</h4>
                        </div>
                    </div>
                    <div className="row g-3 justify-content-center">
                        {/* <h4 className="mb-4">Previous Appointments</h4> */}
                        {appointments.previous.map((item, index, arr) => (
                            <div className="col-md-4 wow fadeInUp" data-wow-delay="0.1s" key={item.id}>
                                <div className="team-item rounded">
                                    <div className="team-img rounded-top h-100 border border-primary border-bottom-0 pt-3">
                                        <img src={item.doctor_profile_picture || (getPublicImgUrl()+'/doctor_2785482.png')} className="img-fluid rounded-top w-100" style={{ maxHeight: '250px', objectFit: 'contain' }} alt="" />
                                    </div>
                                    <div className="team-content text-center border border-primary border-top-0 rounded-bottom p-4">
                                        <h5 className="mb-2">{item.doctor_name}</h5>
                                        <div className="appointment-item-div mb-3"><span className="text-start"><b>Date:</b></span> <span className="text-end">{item.appointment_date}</span></div>
                                        <div className="appointment-item-div mb-3"><span className="text-start"><b>Time:</b></span> <span className="text-end">{item.appointment_time}</span></div>
                                        {/* <div className="appointment-item-div mb-3"><span className="text-start"><b>Reason:</b></span> <span className="text-end">{item.visit_reason}</span></div> */}
                                        <div className="appointment-item-div mb-3"><span className="text-start"><b>Payment Status:</b></span> <span className="text-end">{item.payment_status ?? 'N/A'}</span></div>
                                        <div className="appointment-item-div mb-3"><span className="text-start"><b>Booking Status:</b></span> <span className="text-end">{item.booking_status ?? 'N/A'}</span></div>
                                        <div className="appointment-item-div mb-3"><span className="text-start"><b>Fees:</b></span> <span className="text-end"><b>&#8377;{item.total_amount}</b></span></div>
                                        <hr />
                                        <button type="button" onClick={() => navigate(`/dashboard/patient/appointment/${item.id}`)} className="btn btn-primary">View Details</button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                )}
            </div>
        </>
    );
}